// Shared thresholds for peek <-> full sheet transitions. Matches FAA v2
// drawer spec and the mobile drag gesture in `useSheetDrag`.
export const EXPAND_DRAG_PX = 40;

export const PEEK_DISMISS_PX = 40;

export const EXPANDED_COLLAPSE_PX = 80;

// Velocity threshold (px/ms) above which the gesture direction overrides
// the positional thresholds above. Retained from v1 for flick-to-dismiss.
export const VELOCITY_OVERRIDE_PX_PER_MS = 0.5;
